module.exports = __webpack_public_path__ + "static/media/DSC_0096.fcd1194b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0096.jpg
// module id = 632
// module chunks = 0